/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { LookupSourceType } from '../models/lookup-source-type';
export interface LookupSourceDefinition {
  quickCreateFormName?: string | null;
  type?: LookupSourceType;
}

export class LookupSourceDefinition {
  quickCreateFormName?: string | null;
  type?: LookupSourceType;

  constructor(value: LookupSourceDefinition) {
    this.quickCreateFormName = value?.quickCreateFormName;
    this.type = value?.type ? Object.entries(Object.values(LookupSourceType)).flatMap((x) => x).find(x => x === value.type) as LookupSourceType : undefined;
  }
}
